/**
 * Formatea una fecha en formato dd/mm/yyyy con ceros delante
 * @param date - Fecha a formatear (string ISO o Date)
 * @returns Fecha formateada como "28/01/2026"
 */
export function formatDate(date: string | Date): string {
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';

  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const year = d.getFullYear();

  return `${day}/${month}/${year}`;
}
